import Vue from 'vue'
import Config from '../../config'
import store from '../store/store'
// axios
import axios from 'axios'

const axiosIns = axios.create({
	// You can add your headers here
	// ================================
	baseURL: Config.apiUrl,
	// timeout: 1000,
	headers: {
		'x-pathname': window.location.pathname,
		'x-origin': window.location.origin,
	}
})


axiosIns.interceptors.request.use(
	request => {
		if (request.page_overlay != false) {
			store.commit('PAGE_LOADING', true)
		}
		return request
	},
	error => Promise.reject(error),
)

axiosIns.interceptors.response.use(
	response => {
		store.commit('PAGE_LOADING', false)
		return response
	},
	error => {
		store.commit('PAGE_LOADING', false)
		return Promise.reject(error)
	},
)


axiosIns.ENDPOINT = {

	// Lấy thông tin đề thi
	GET_EXAM: '/get-questions',

	// Lấy bài thi đang làm theo mã đề
	GET_EXAM_HISTORY: '/get-test-history',

	// Lấy trackingId,
	INIT_TRACKID: '/track/init',

	// Tao bai test
	TEST_CREATE: '/test-create',

	// push contact
	PUSH_CONTACT: '/track/push-contact-v2',

	// push contact
	PUSH_SURVEY: '/track/push-survey',

	// Lưu bài test
	TEST_SAVE: '/test-save-v2',

	// Danh dau bai thi hoan thanh (truong hop bo qua bai thi dang lam)
	TEST_DONE: '/test-done',
}


Vue.prototype.$http = axiosIns

export default axiosIns
